import dynamic from 'next/dynamic';
import Footer from './footer';
import Header from './header';
import NotFoundTastic from './not-found';
import { TasticRegistry } from './types';

const Account = dynamic(() => import('./account/details'));
const AccountLogin = dynamic(() => import('./account/login'));
const AccountRegister = dynamic(() => import('./account/register'));
const ResetPassword = dynamic(() => import('./account/reset-password'));
const Checkout = dynamic(() => import('./checkout'));
const ThankYou = dynamic(() => import('./thank-you'));
const ProductDetails = dynamic(() => import('./products/details'));
const Wishlist = dynamic(() => import('./wishlist'));
const CategoryPLPTastic = dynamic(() => import('./products/product-list/CategoryPLPTastic'));
const SearchPLPTastic = dynamic(() => import('./products/product-list/SearchPLPTastic'));
const Cart = dynamic(() => import('./cart'));
const AmplienceContent = dynamic(() => import('./amplience/content'));
const AmplienceVisualization = dynamic(() => import('./amplience/visualization'));
const CheckoutHeaderTastic = dynamic(() => import('./layout/checkout-header'));
const CheckoutFooterTastic = dynamic(() => import('./layout/checkout-footer'));
const ForgotPassword = dynamic(() => import('./forgot-password'));
const CommunicationsPreferencesThankYou = dynamic(() => import('./communications-preferences-thank-you'));
const OrderLookup = dynamic(() => import('./orders/lookup'));
const OrderDetail = dynamic(() => import('./orders/detail'));
const OrderReturn = dynamic(() => import('./orders/return'));

export const tastics = {
  'commercetools/ui/thank-you': ThankYou,
  'commercetools/ui/footer': Footer,
  'commercetools/ui/header': Header,
  'sol/ui/checkout-header': CheckoutHeaderTastic,
  'sol/ui/checkout-footer': CheckoutFooterTastic,
  'sol/ui/checkout': Checkout,
  'commercetools/ui/cart': Cart,
  'commercetools/ui/products/details': ProductDetails,
  'commercetools/ui/products/category-plp': CategoryPLPTastic,
  'commercetools/ui/products/search-plp': SearchPLPTastic,
  'commercetools/ui/account/details': Account,
  'commercetools/ui/account/login': AccountLogin,
  'commercetools/ui/account/register': AccountRegister,
  'commercetools/ui/account/reset-password': ResetPassword,
  'commercetools/ui/account/forgot-password': ForgotPassword,
  'commercetools/ui/not-found': NotFoundTastic,
  'amplience/content': AmplienceContent,
  'amplience/visualization': AmplienceVisualization,
  'commercetools/ui/wishlist': Wishlist,
  'commercetools/ui/account/communications-preferences-thank-you': CommunicationsPreferencesThankYou,
  'commercetools/ui/orders/lookup': OrderLookup,
  'commercetools/ui/orders/detail': OrderDetail,
  'commercetools/ui/orders/return': OrderReturn,
} as TasticRegistry;
